import React from "react";
import { AssetIcon } from "../../assets";
import PrimaryActionButton from "./PrimaryActionButton";
import RowActions from "./RowActions";
import IconActions from "../IconActions";
import StatusPill from "./StatusPill";

export default function EntityCard({
  title,
  subtitle,
  initials,
  status,
  meta = [],
  primaryAction,
  actions = [],
  onClick,
}) {
  const clickable = typeof onClick === "function";
  const hasInlineActions = Boolean(primaryAction || actions.length);
  const keyboardClickable = clickable && !hasInlineActions;

  return (
    <article
      className={clickable ? "wt-entity-card is-clickable" : "wt-entity-card"}
      onClick={onClick}
      role={keyboardClickable ? "button" : undefined}
      tabIndex={keyboardClickable ? 0 : undefined}
      onKeyDown={(event) => {
        if (!keyboardClickable) return;
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClick();
        }
      }}
    >
      <div className="wt-entity-card__top">
        <div className="wt-entity-card__avatar" aria-hidden="true">
          {initials || "?"}
        </div>
        {status ? (
          <StatusPill label={status.label} tone={status.tone || "neutral"} />
        ) : null}
      </div>

      <div className="wt-entity-card__heading">
        <h2>{title}</h2>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>

      {meta.length ? (
        <dl className="wt-entity-card__meta">
          {meta.map((item) => (
            <div
              key={item.id || item.label}
              className={`wt-entity-card__meta-row${item.iconKey ? " wt-entity-card__meta-row--with-icon" : ""}`}
            >
              {item.iconKey ? (
                <AssetIcon name={item.iconKey} size={16} ariaHidden />
              ) : null}
              <dt>{item.label}</dt>
              <dd>{item.value || item.fallback || "Non indicato"}</dd>
            </div>
          ))}
        </dl>
      ) : null}

      {
        <footer
          className="wt-entity-card__footer"
          onClick={(event) => event.stopPropagation()}
        >
          <IconActions>
            {primaryAction ? (
              <PrimaryActionButton
                iconKey={primaryAction.iconKey || "actions.edit"}
                onClick={primaryAction.onClick}
                disabled={primaryAction.disabled}
                className="wt-entity-card__primary-action"
              >
                {primaryAction.label || "Modifica"}
              </PrimaryActionButton>
            ) : null}
            {actions.length ? <RowActions actions={actions} /> : null}
          </IconActions>
        </footer>
      }
    </article>
  );
}
